import Vue from 'vue'
import App from './App.vue'

import {router} from "@/router"
import store from '@/store';
import * as api from '@/api';

import '@/assets/style/reset.css'
import '@/plugins/ElementUi'

import SuspensionBox from '@/components/SuspensionBox'
import MyTitle from '@/components/MyTitle'

Vue.component('SuspensionBox', SuspensionBox)
Vue.component('MyTitle', MyTitle)

import {goAnchorModel} from '@/utils/goAnchorModel'

// 禁用浏览器开发者工具
// import * as ConsoleBan from 'console-ban'
// ConsoleBan.init({redirect: '/console-ban'})

// 百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {ak: 'SpNplrQpO0IDl0e72CwRORGWNzTA1S9R'})

//图片懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: require('@/assets/images/loading.gif'),
  // error: require('@/assets/images/loading.gif'),
  attempt: 1
})

// 滚动到指定位置元素渐入
import AOS from "aos";
import "../node_modules/aos/dist/aos.css";

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store,
  router,
  created() {
    // 元素渐入
    AOS.init({
      once: true,
    });
  },
  beforeCreate() {
    Vue.prototype.$bus = this;
    Vue.prototype.$api = api;
    Vue.prototype.goAnchorModel = goAnchorModel;
  },
}).$mount('#app')